@let seatsByPax = selectedSeatsByPax$ | async;
@let bundlesByPax = selectedBundleCategoriesByPax$ | async;
@let shouldShowRemoveButtonByPax = shouldShowRemoveButtonByPax$ | async;

@if (passengers$ | async; as passengers) {
  <h3 class="font-heading-4 ps-xsmall-b dn-tablet-down">
    {{ 'seatMap.passengersTitle' | finLocalization }}
  </h3>
  <div class="flex flex--wrap dn-mobile ps-medium-b">
    <button
      *ngFor="let passenger of passengers; let index = index"
      class="pax-selector font-body-1 ms-xsmall-y ms-xsmall-r ps-xsmall border rounded-medium flex flex--middle"
      [attr.data-testid]="'passenger-chip'"
      [attr.data-pax-id]="passenger.id"
      [class.active]="passenger.id === activePax.id"
      (click)="handleClick(passenger.id, index)"
    >
      <fcom-icon [name]="SvgLibraryIcon.SINGLE_PAX" class="icon-medium" />
      <div class="ms-xsmall-l font-body-1 flex flex--middle" data-hj-suppress>
        <span class="pax-name truncate overflow-hidden" data-hj-suppress
          >{{ passenger.traveler.firstName }} {{ passenger.traveler.lastName }}</span
        >
        @if (passenger.withInfant) {
          <span class="ps-xxsmall-l">
            ({{ 'seatMap.and' | finLocalization }} {{ passenger.withInfantFullName }} )
          </span>
        }
        @if (seatsByPax[passenger.id]) {
          <div
            [ngClass]="{
              'nordic-blue-900-text white-bg': passenger.active,
              'white-text nordic-blue-900-bg': !passenger.active,
            }"
            class="rounded-medium ms-xsmall-l flex flex--middle"
            [attr.data-testid]="'seat-number-pax-' + (index + 1)"
          >
            <span [attr.data-testid]="'seat-number-' + passenger.id" class="font-body-2 ms-xxsmall-x">{{
              seatsByPax[passenger.id]
            }}</span>

            @if (bundlesByPax[passenger.id]?.length > 0) {
              <fcom-icon
                class="ms-xxsmall-r icon-small"
                [name]="getIconForServiceCategory(bundlesByPax[passenger.id][0])"
              />
            }
            @if (bundlesByPax[passenger.id]?.length > 0) {
              <span class="is-vishidden"
                >+ {{ 'ancillaries.' + bundlesByPax[passenger.id][0] + '.extraTitle' | finLocalization }}</span
              >
            }
          </div>
        }
        @if (shouldShowRemoveButtonByPax?.[passenger.id]) {
          <fcom-icon-button
            class="close ms-xsmall-l flex flex--middle"
            [icon]="{ name: SvgLibraryIcon.CLOSE_DELETE }"
            [theme]="passenger.active ? IconButtonTheme.DARK_TERTIARY_GHOST : IconButtonTheme.LIGHT_TERTIARY_GHOST"
            [size]="IconButtonSize.SMALL"
            [aria]="{ label: 'seatMap.passengers.removeSeat' | finLocalization }"
            (clickBtn)="clearSelection(passenger.id)"
            [dataTestId]="'passenger-chip-remove'"
          />
        }
      </div>
    </button>
  </div>

  @if (options$ | async; as options) {
    <form [formGroup]="passengerForm" class="dn-tablet-up ps-medium-y">
      <fin-select-input
        class="fill"
        [parentForm]="passengerForm"
        [controlName]="'activeTravelerId'"
        [options]="options"
        [displayMargin]="false"
        [translationPrefix]="'seatMap.passengers'"
        [disableSelectOption]="true"
        [label]="
          'seatMap.passengers.label'
            | finLocalization
              : {
                  selected: 0,
                  total: passengers.length,
                }
        "
        data-hj-suppress
      />
    </form>
  }
}
